var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnerDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 50C27.732 50 34 44.6274 34 38C34 31.3726 27.732 26 20 26C12.268 26 6 31.3726 6 38C6 44.6274 12.268 50 20 50Z",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 15.8827C26 12.6336 23.3113 10 19.9942 10C16.677 10 14 12.6336 14 15.8827C14 15.9625 14 16.0309 14.0116 16.1107C14.0116 16.1221 14.0116 16.1336 14.0116 16.145C14.0116 16.2362 14.0233 16.316 14.0349 16.4072C14.0349 16.4186 14.0349 16.43 14.0349 16.4414C14.0349 16.4642 14.0349 16.4756 14.0349 16.4984C14.3841 20.6938 16.3162 22.5521 17.6198 23.3274C17.8991 23.4984 18.1901 23.6466 18.5044 23.7492C18.7139 23.829 18.8303 23.8518 18.8419 23.8518C19.2144 23.9544 19.5984 24 19.9942 24C20.3899 24 20.7856 23.943 21.1465 23.8518C21.1465 23.8518 21.2745 23.829 21.484 23.7492C21.7983 23.6352 22.1009 23.4984 22.3686 23.3274C23.6722 22.5521 25.6043 20.7052 25.9534 16.4984C25.9534 16.4756 25.9534 16.4642 25.9534 16.4414C25.9534 16.43 25.9534 16.4186 25.9534 16.4072C25.9651 16.316 25.9651 16.2362 25.9767 16.145C25.9767 16.1336 25.9767 16.1221 25.9767 16.1107C26 16.0309 26 15.9511 26 15.8827Z",
    fill: "#DEDFE1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerDefaultAvatar);
export default __webpack_public_path__ + "static/media/owner-default-avatar.c3ff3b9c.svg";
export { ForwardRef as ReactComponent };